/**
 * KPI-Karte (NKM/EBTDA/JÜ/RoE). Rendert null sauber als "—"/"geplant",
 * NIE als 0 (SCHEMA_MAPPING §5). Optionale Ampel + „geschätzt"-Marker (RoE).
 */
import type { ReactNode } from 'react';
import { formatValue } from '../lib/format';
import type { FormatKind } from '../lib/format';
import { Ampel } from './Ampel';

export interface KpiCardProps {
  label: string;
  value: number | null | undefined;
  kind?: FormatKind;
  /** Text für null. Default "—". Im reinen SOLL-Kontext z.B. "geplant". */
  nullText?: string;
  abweichungPct?: number | null;
  /** RoE: als „geschätzt" kennzeichnen (SCHEMA_MAPPING §3/§7). */
  estimated?: boolean;
  footer?: ReactNode;
}

export function KpiCard({
  label,
  value,
  kind = 'eur',
  nullText,
  abweichungPct,
  estimated = false,
  footer,
}: KpiCardProps) {
  const display = formatValue(value, { kind, nullText });
  const isNull = value === null || value === undefined || Number.isNaN(value as number);

  return (
    <div className="rounded-lg border border-border bg-surface p-4 shadow-sm">
      <div className="flex items-baseline justify-between gap-2">
        <h3 className="text-sm font-medium text-text-muted">{label}</h3>
        {estimated && (
          <span className="rounded bg-surface-2 px-1.5 py-0.5 text-xs text-text-muted">
            geschätzt
          </span>
        )}
      </div>
      <div className="mt-2 flex items-end justify-between gap-3">
        <span
          className={`text-2xl font-semibold tabular-nums ${isNull ? 'text-text-muted' : 'text-text'}`}
        >
          {display}
        </span>
        {abweichungPct !== undefined && <Ampel abweichungPct={abweichungPct} showValue />}
      </div>
      {footer && <div className="mt-2 text-xs text-text-muted">{footer}</div>}
    </div>
  );
}
